import Vue from 'vue';
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import qs from 'qs';

var loader = null;
// shared method
function hideLoader(){
  console.log('hideLoader');
  loader && loader.hide();
  loader = null;
}
axios.interceptors.request.use(
  cfg => {
    if (store.getters.isAuthenticated) {
      console.log('axios request store', store);
      console.log('axios request cfg', cfg);
      console.log('store.getters.getEstablecimiento', store.getters.getEstablecimiento);
      if(!store.getters.getEstablecimiento){
        if(store.getters.getSelectEstablecimiento[0])
        {
          console.log('store.getters.getSelectEstablecimiento', store.getters.getSelectEstablecimiento);
          store.commit('setEstablecimiento', store.getters.getSelectEstablecimiento[0].value);
          console.log('no estaba seleccionado el establecimiento');
          throw 'Debe seleccionar un establecimiento';
        }
      }
      const auth = store.getters.getAuth;
      // eslint-disable-next-line
      // OJO: se compara con "!== undefined" (no con truthy/"? :") a propósito.
      // Con "? :", un 0 explícito (p.ej. "sin restricción de unidad
      // administrativa") se trataba como "no vino" y se pisaba igual con el
      // valor del establecimiento actual - impedía que ninguna pantalla
      // pudiera pedir explícitamente "todas las unidades administrativas".
      if(cfg.params){
        cfg.params.nivelenseñanza_id = cfg.params.nivelenseñanza_id !== undefined ? cfg.params.nivelenseñanza_id : store.getters.getEstablecimiento ? store.getters.getEstablecimiento.NivelEnseñanza_Id ? store.getters.getEstablecimiento.NivelEnseñanza_Id : 0 : 0;
        cfg.params.unidadeducativa_id = cfg.params.unidadeducativa_id !== undefined ?  cfg.params.unidadeducativa_id : store.getters.getEstablecimiento ? store.getters.getEstablecimiento.UnidadEducativa_Id ? store.getters.getEstablecimiento.UnidadEducativa_Id : 0 : 0;
        cfg.params.unidadadministrativa_id = cfg.params.unidadadministrativa_id !== undefined ? cfg.params.unidadadministrativa_id : store.getters.getEstablecimiento ? store.getters.getEstablecimiento.UnidadAdministrativa_Id ? store.getters.getEstablecimiento.UnidadAdministrativa_Id : 0 : 0;
      }
      if(cfg.data && !cfg.url.includes("upload")){
        cfg.data.nivelenseñanza_id = cfg.data.nivelenseñanza_id !== undefined ? cfg.data.nivelenseñanza_id : store.getters.getEstablecimiento ? store.getters.getEstablecimiento.NivelEnseñanza_Id ? store.getters.getEstablecimiento.NivelEnseñanza_Id : null : null;
        cfg.data.unidadeducativa_id = cfg.data.unidadeducativa_id !== undefined ?  cfg.data.unidadeducativa_id : store.getters.getEstablecimiento ? store.getters.getEstablecimiento.UnidadEducativa_Id ? store.getters.getEstablecimiento.UnidadEducativa_Id : null : null;
        cfg.data.unidadadministrativa_id = cfg.data.unidadadministrativa_id !== undefined ? cfg.data.unidadadministrativa_id : store.getters.getEstablecimiento ? store.getters.getEstablecimiento.UnidadAdministrativa_Id ? store.getters.getEstablecimiento.UnidadAdministrativa_Id : null : null;
        cfg.data = qs.stringify(cfg.data);
      }
      cfg.headers.Authorization = `${auth.token_type} ${auth.access_token}`;
    }

    if (loader) {
      console.log('loader ya existe');
      return cfg;
    }
    console.log('loader nuevo');
    loader = Vue.$loading.show();

    console.log('axios request cfg modificado', cfg);
    return cfg;
  },
  err => Promise.reject(err)
)

axios.interceptors.response.use(
  res => {
    hideLoader();
    return res;
  },
  // eslint-disable-next-line
  err => {
    console.log('axios error', err);
    hideLoader();
    if (!err.response) {
      console.log('!err.response');
      var response = {data: {error_description: 'Network Error'}};
      err['response'] = response;
      return Promise.reject(err)
    }
    switch (err.response.status) {
      case 401:
        store.commit('removeAuthentication');
        router.push({
          path: '/login',
          query: {
            redirect: router.app._route.fullPath
          }
        });
        break;
      default:
        return Promise.reject(err);
    }
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/axios/index.js